import {baseUrl} from'../config';

export const feedbackController ={
    getAllFeedbacks:baseUrl+'/api/feedback',
} 